import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import type { Locales } from 'constants/app';
import { setLocale } from 'store/app/slice';
import { useAppDispatch } from 'store/hooks';

import type { TranslationKey } from '../locales/flattenMessages';

const useTranslate = () => {
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();

  const t = useCallback(
    (key: TranslationKey, values?: any) => formatMessage({ id: key }, values),
    [formatMessage],
  );

  const changeLocale = (locale: Locales) => {
    localStorage.setItem('locale', locale);
    window.location.hash = `#${locale}`;
    dispatch(setLocale(locale));
  };

  return { t, changeLocale };
};

export { useTranslate };
